import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";

import { AddressInfoCard } from "components/CaseMap/AddressInfoCard";
import { AddressMarkerPin } from "components/CaseMap/AddressMarkerPin";
import { Z_INDEX } from "components/CaseMap/mapLayers";
import { formatAddress } from "helpers/address";

/**
 * One of the case's addresses, plus its summary once clicked.
 *
 * Its own component because the marker ref the InfoWindow anchors to comes from
 * a hook, which cannot live inside the layer's map callback.
 */
export function AddressMarker({
  address,
  caseName,
  position,
  summaryOpen,
  onSelect,
  onClose,
}) {
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        title={formatAddress(address)}
        zIndex={summaryOpen ? Z_INDEX.openAddress : Z_INDEX.address}
        onClick={() => onSelect(address.id)}
      >
        <AddressMarkerPin selected={summaryOpen} />
      </AdvancedMarker>
      {summaryOpen && (
        <InfoWindow
          anchor={marker}
          maxWidth={320}
          onCloseClick={onClose}
          headerDisabled
        >
          <AddressInfoCard
            address={address}
            caseName={caseName}
            position={position}
          />
        </InfoWindow>
      )}
    </>
  );
}
